import api from '../../api/index.js'

const state = {

}

const getters = {

}

const actions = {
    DistributionProductSearch({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/DistributionProduct/DistributionProductSearch',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    GetDistributionProductById({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/DistributionProduct/GetDistributionProductById',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    }
}

const mutations = {

}

export default {
    state,
    getters,
    actions,
    mutations
}
